// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2587":"62bd6b023950fb4f","8974":"f39c51466e7226c0"}[chunkId] + ".js";
};